import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'JFUT',
  description:
    'The most popular AMM on BSC by user count! Earn CAKE through yield farming or win it in the Lottery, then stake it in JFUT Pools to earn more tokens! Initial Farm Offerings (new token launch model pioneered by JFUT), NFTs, and more, on a platform you can trust.',
  image: 'https://joyfun.pages.dev/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else if (path.startsWith('/nfts/collections')) {
    basePath = '/nfts/collections'
  } else if (path.startsWith('/nfts/profile')) {
    basePath = '/nfts/profile'
  } else if (path.startsWith('/pancake-squad')) {
    basePath = '/pancake-squad'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `JOYFUN | ${t('Home')}`,
      }
    case '/swap':
      return {
        title: `JOYFUN | ${t('Exchange')}`,
      }
    case '/add':
      return {
        title: `JOYFUN | ${t('Add Liquidity')}`,
      }
    case '/remove':
      return {
        title: `JOYFUN | ${t('Remove Liquidity')}`,
      }
    case '/liquidity':
      return {
        title: `JOYFUN | ${t('Liquidity')}`,
      }
    case '/find':
      return {
        title: `JOYFUN | ${t('Import Pool')}`,
      }
    case '/competition':
      return {
        title: `JOYFUN | ${t('Trading Battle')}`,
      }
    case '/prediction':
      return {
        title: `JOYFUN | ${t('Prediction')}`,
      }
    case '/prediction/leaderboard':
      return {
        title: `JOYFUN | ${t('Leaderboard')}`,
      }
    case '/farms':
      return {
        title: `JOYFUN | ${t('Farms')}`,
      }
    case '/farms/auction':
      return {
        title: `JOYFUN | ${t('Farm Auctions')}`,
      }
    case '/pools':
      return {
        title: `JOYFUN | ${t('Pools')}`,
      }
    case '/lottery':
      return {
        title: `JOYFUN | ${t('Lottery')}`,
      }
    case '/ifo':
      return {
        title: `JOYFUN | ${t('Initial Farm Offering')}`,
      }
    case '/teams':
      return {
        title: `JOYFUN | ${t('Leaderboard')}`,
      }
    case '/voting':
      return {
        title: `JOYFUN | ${t('Voting')}`,
      }
    case '/voting/proposal':
      return {
        title: `JOYFUN | ${t('Proposals')}`,
      }
    case '/voting/proposal/create':
      return {
        title: `JOYFUN | ${t('Make a Proposal')}`,
      }
    case '/info':
      return {
        title: `JOYFUN | ${t('Overview')} | ${t('JOYFUN Info & Analytics')}`,
        description: 'View statistics for Pancakeswap exchanges.',
      }
    case '/info/pools':
      return {
        title: `JOYFUN | ${t('Pools')} | ${t('JOYFUN Info & Analytics')}`,
        description: 'View statistics for Pancakeswap exchanges.',
      }
    case '/info/tokens':
      return {
        title: `JOYFUN | ${t('Tokens')} | ${t('JOYFUN Info & Analytics')}`,
        description: 'View statistics for Pancakeswap exchanges.',
      }
    case '/nfts':
      return {
        title: `JOYFUN | ${t('Overview')}`,
      }
    case '/nfts/collections':
      return {
        title: `${t('Collections')}`,
      }
    case '/nfts/profile':
      return {
        title: `${t('Your Profile')}`,
      }
    case '/pancake-squad':
      return {
        title: `${t('Pancake Squad')}`,
      }
    default:
      return null
  }
}
